import { userPrefs } from "../../prefs";
import BasicRecord from "../BasicRecord";
import { isValentines } from "../celebration";

export async function trackEventInUserPrefs(eventName: string) {
    const events: BasicRecord<boolean> = (await userPrefs.get("events")) ?? {};

    if (events[eventName]) {
        return;
    }

    return userPrefs.set("events", {
        ...events,
        [eventName]: true
    });
}

export async function saveDismissedTooltipInUserPrefs(tooltipName: string) {
    const dismissedTooltips: BasicRecord<boolean> = (await userPrefs.get("dismissedTooltips")) ?? {};

    if (dismissedTooltips[tooltipName]) {
        return;
    }

    return userPrefs.set("dismissedTooltips", {
        ...dismissedTooltips,
        [tooltipName]: true
    });
}

export async function saveLastGuidanceDisplayedDateInUserPrefs(eventGroup: string) {
    const guidanceLastDisplayDates: BasicRecord<boolean> = (await userPrefs.get("guidanceLastDisplayDates")) ?? {};

    return userPrefs.set("guidanceLastDisplayDates", {
        ...guidanceLastDisplayDates,
        [eventGroup]: Date.now()
    });
}

export function getValentinesDotStatus(screenId: string, valentinesDates: Record<number, { sid: string; status: "unread" | "seen" | "dismissed"; } | undefined> = {}): "unread" | "seen" | "dismissed" | null {
    if (!isValentines()) {
        return null;
    }

    const currentYear = new Date().getFullYear();
    const valentinesDate = valentinesDates[currentYear];

    if (valentinesDate === undefined) {
        return null;
    }

    if (valentinesDate.sid !== screenId) {
        return null;
    }

    return valentinesDate.status;
}
